import React, { useState } from 'react';
import { Box, Paper, Typography, Divider, Stack, Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import MasterFormsTable from './MasterFormsTable';
import CreateFormDialog from './CreateFormDialog';
import EditFormDialog from './EditFormDialog';

const FormManagementIndex = () => {
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleEdit = (form) => {
    setSelectedForm(form);
    setEditDialogOpen(true);
  };

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  const handleCreateSuccess = () => {
    handleRefresh();
  };

  const handleEditSuccess = () => {
    handleRefresh();
  };

  return (
    <Box sx={{ p: 2 }}>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>Review Management</Typography>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => setCreateDialogOpen(true)}
            size="small"
          >
            Create New Form
          </Button>
        </Stack>
      </Paper>

      <Box sx={{ mt: 2 }}>
        <MasterFormsTable 
          onEdit={handleEdit}
          onRefresh={handleRefresh}
          key={refreshTrigger}
        />
      </Box>

      {/* Create Form Dialog */}
      <CreateFormDialog
        open={createDialogOpen}
        onClose={() => setCreateDialogOpen(false)}
        onSuccess={handleCreateSuccess}
      />

      {/* Edit Form Dialog */}
      <EditFormDialog
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        form={selectedForm}
        onSuccess={handleEditSuccess}
      />
    </Box>
  );
};

export default FormManagementIndex;
